import StylusShape from './StylusShape';
import NoteMenu from '../toolbars/NoteMenu';
import type WhiteboardController from '../controllers/WhiteboardController';

// Stylus for creating note shapes.
class StylusNote extends StylusShape {
  fill?: string;

  constructor({
    controller,
    fill,
  }: {
    controller: WhiteboardController;
    fill?: string;
  }) {
    super({ controller, shapeName: 'note' });
    this.fill = fill;
    this.options = {};
    if (this.fill) {
      this.options.fill = this.fill;
    }
  }

  activate() {
    super.activate();

    // Use this note colour as the default one from now on
    if (this.fill) {
      this.controller.defaultsManager.setForCategory(
        'shape_note',
        'fill',
        this.fill
      );
    }
  }

  cursor() {
    return 'crosshair';
  }

  subMenu() {
    return NoteMenu;
  }

  subMenuName() {
    return 'notes';
  }

  fillColor() {
    return this.fill;
  }

  setFillColor(color: string) {
    this.fill = color;
    this.options.fill = color;
  }
}

export default StylusNote;
